export default __webpack_public_path__ + "static/careers-illustration-339a84ebeacff880366851a675124f7918073e6abbb74960fdee44e7e356a6ba.png";